export const convertToBooleans = (obj: any) => {
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (obj[key] === 'true') {
                obj[key] = true;
            } else if (obj[key] === 'false') {
                obj[key] = false;
            }
        }
    }
    return obj;
};
